import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { TrainingService } from "../../api/TrainingService";
import { useAssetHandler } from "../../hooks/useAssetHandler";
import useTranslation from "../../hooks/useTranslation";
import TrainingModule from "../../models/trainingModule";
import { getDropdownItems } from "../../utils/Training.utils";
import { TrainingModuleContent } from "./TrainingModuleContent/TrainingModuleContent";
import { TrainingModuleOverviewFooter } from "./TrainingModuleOverviewFooter/TrainingModuleOverviewFooter";
import "./TrainingModuleOverview.scss";

interface TrainingModuleOverviewProps {
  trainingModule: TrainingModule;
}

export const TrainingModuleOverview = ({
  trainingModule,
}: TrainingModuleOverviewProps) => {
  const { t } = useTranslation("trainingPage");
  const trainingModuleId = trainingModule.referenceId;
  const trainingService = new TrainingService();

  const { error: downloadError, refetch: refetchTrainingModule } = useQuery<
    Blob,
    AxiosError
  >(
    ["trainingDownload"],
    () => trainingService.downloadTrainingModule(trainingModuleId),
    {
      refetchOnWindowFocus: false,
      enabled: false,
      retry: false,
    }
  );

  const { handleAssetSelect, assetDownloadError } = useAssetHandler(
    trainingModule.referenceId
  );
  const dropdownItems = getDropdownItems(trainingModule.assets, t);

  return (
    <div className="TrainingModuleOverview">
      <div className="TrainingModuleOverview__header">
        <img
          className="TrainingModuleOverview__header__thumbnail"
          src={trainingModule.gradient}
          alt=""
        />
      </div>
      <TrainingModuleContent trainingModule={trainingModule} />
      <TrainingModuleOverviewFooter
        assetDownloadError={assetDownloadError}
        canAccess={trainingModule.canAccess}
        deliveryMethod={trainingModule.deliveryMethod}
        downloadError={downloadError ? true : false}
        dropdownItems={dropdownItems}
        handleAssetSelect={handleAssetSelect}
        refetchTrainingModule={() => refetchTrainingModule()}
        t={t}
        trainingModule={trainingModule}
      />
    </div>
  );
};
